import { sha256 } from 'js-sha256';
import * as i0 from "@angular/core";
var HashService = /** @class */ (function () {
    function HashService() {
    }
    HashService.prototype.getParametersHash = function (params) {
        var str = JSON.stringify(params, Object.keys(params).sort());
        return this.sha256(str);
    };
    HashService.prototype.sha256 = function (str) {
        return sha256(str);
    };
    HashService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HashService_Factory() { return new HashService(); }, token: HashService, providedIn: "root" });
    return HashService;
}());
export { HashService };
